module.exports = __webpack_public_path__ + "static/staples-39dc727c2f42c476549003aa90bce05b.jpg";